import React from "react"

import { IntegrationCard } from "./integration-card"

interface Props {
	name: string | React.ReactNode
	logo: React.ReactNode
	description: string
	instructions?: React.ReactNode
	button?: React.ReactElement | null
	notice?: React.ReactNode
	image?: string
	alt?: string
}

function IntegrationTemplate(props: Props) {
	return <IntegrationCard variant="page" {...props} />
}

export { IntegrationTemplate }
